import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelLargeBold,
    CustomLabelLargeBoldIntro,
    CustomLabelLargeBoldRedHat,
    CustomLabelMediumRegular,
    CustomLabelMediumRegularInto,
    CustomLabelMediumRegularRedHatInto,
    CustomLabelMediumSmallBold, CustomLabelRegularMedium, CustomLabelSmallBold,
    CustomLabelSmallRegular,
    CustomLabelXSmallRegular,
    CustomLabelLargeBoldIntroHead
} from "../common/CustomLabel";
import PEACE_HAND from "../../assets/images/peace-hand.png";
import ARROW_RIGHT from "../../assets/images/arrow-right-tag.png";
import {motion} from "framer-motion";
import Box from "@mui/material/Box/Box";
import CIRCULAR_LOGO from "../../assets/images/circular-logo.png";
import COMPUTER_LOGO from "../../assets/images/computer.png";
import React from "react";
import createTheme from "@mui/material/styles/createTheme";
import {useMediaQuery} from "@mui/material";
import {useTheme} from '@mui/material';

import {ThemeProvider} from '@mui/material';
import {CustomTextField} from "../common/text";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import USER from "../../assets/images/user.png";
import Paper from "@mui/material/Paper/Paper";
import WorkCard from "../card-work";
import WorkDetails from "../work-details";


import PROJECT1 from 'src/assets/images/project_1.png';
import PROJECT2 from 'src/assets/images/project2.png';
import PROJECT3 from 'src/assets/images/project3.png';

import SERVICES_BANNER from "../../assets/images/services-banner.png";


const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1350
        },
    },
});


const IntroDetails = ({title, description, tag, onChange,hideSearch}) => {

    const textColor = title === "Premium Software Development Services USA" ? "#FFFFFF" : "#333333";
    const titleColor = title === "Premium Software Development Services USA" ? "#FFFFFF" : "#5E16EB";
    const titleTopxs = title === "Premium Software Development Services USA" ? "120px" : "20px";
    const titleTopmd = title === "Premium Software Development Services USA" ? "180px" : "40px";

    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    return (
        <ThemeProvider theme={theme}>
            <Grid container justifyContent={"center"}
                  sx={{
                    //   marginTop: {xs: '10px', md: '30px'},
                      padding: {xs: '0px 0px', sm: "12px 0px", md: '12px 20px', lg: "12px 40px", xl: "12px 60px"},
                  }}>
                <Grid item container xs={11} md={11} justifyContent={"center"} sx={{marginTop: {xs: titleTopxs, md: titleTopmd}}}>
                    <CustomLabelLargeBoldIntroHead fontWeight={"bold"} style={{textAlign: "center"}} color={titleColor}
                                                text={title}></CustomLabelLargeBoldIntroHead>
                </Grid>


                <Grid item container xs={11} md={9.5} justifyContent={"center"} sx={{marginTop: {xs:"15px"}}}>
                    <CustomLabelMediumRegularRedHatInto color={textColor} style={{textAlign: {xs: "left", md: "center"}, lineHeight: 1.4}}
                                                        text={description}></CustomLabelMediumRegularRedHatInto>
                </Grid>

                <Grid item container xs={11} md={9} justifyContent={"center"} sx={{marginTop: {xs:"15px", md:"25px"}}}>
                    <CustomLabelMediumSmallBold color={textColor} textAlign={"center"} lineHeight={1.4}
                                                        text={tag}></CustomLabelMediumSmallBold>
                </Grid>
            </Grid>

{/* 
                {
                    !hideSearch &&
                    <Grid item xs={10} sm={8} md={6} lg={4.5} container justifyContent={"flex-start"}
                          sx={{marginTop: {xs: "40px", md: "60px"}}}>
                        <Grid item style={{marginLeft: 10}}>
                        </Grid>
                        <Grid item container style={{marginTop: 5}}>
                            <CustomTextField placeholder={"Search..."}
                                             height={"70px"}
                                             onChange={onChange}
                                             startAdornment={
                                                 <InputAdornment position="start">
                                                     <img src={USER}/>
                                                 </InputAdornment>

                                             }/>
                        </Grid>
                    </Grid>
                } */}


        </ThemeProvider>
    )
}

export default IntroDetails;
